module.exports = __webpack_public_path__ + "media/images/responsive/costumes/color_checked-40b2bb25ce2aaa35186e17344b7885cf.svg";